import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiMethod } from '../decorators/api-method.decorator';
import { Item } from '../models/item.model';
import { UserContactInfo } from '../models/user-contact-info.model';
import { AuthService } from './auth.service';
import { AssetItemDetails } from '../models/asset-item-details.model';

@Injectable({
	providedIn: 'root'
})
export class LookupService {

	private readonly baseUrl = `${environment.baseUrl}/lookup`;

	constructor(
		private http: HttpClient,
		private authService: AuthService
	) { }

	@ApiMethod()
	public getJobStatuses(): Observable<Item<number, string>[]> {
		return this.http.get<Item<number, string>[]>(`${this.baseUrl}/job/statuses`);
	}

	@ApiMethod()
	public getJobStatusChangeReasons(statusId: number): Observable<Item<number, string>[]> {
		return this.http.get<Item<number, string>[]>(`${this.baseUrl}/job/status/${statusId}/reasons`);
	}

	@ApiMethod()
	public getDocumentTypes(token: string): Observable<Item<number, string>[]> {
		return this.http.get<Item<number, string>[]>(`${this.baseUrl}/job/${token}/document/types`);
	}

	@ApiMethod()
	public getJobCommentTopics(): Observable<Item<number, string>[]> {
		return this.http.get<Item<number, string>[]>(`${this.baseUrl}/comments/topics`);
	}

	@ApiMethod()
	public getJobFollowUpTypes(): Observable<Item<number, string>[]> {
		return this.http.get<Item<number, string>[]>(`${this.baseUrl}/comments/types`);
	}

	@ApiMethod()
	public getDocumentationAssetTypes(token: string): Observable<Item<number, string>[]> {
		return this.http.get<Item<number, string>[]>(`${this.baseUrl}/job/${token}/documentation/asset-types`);
	}

	@ApiMethod()
	public getDescriptiveTags(token: string, documentTypeMappingId: number): Observable<Item<number, string>[]> {
		return this.http.get<Item<number, string>[]>(`${this.baseUrl}/job/${token}/${documentTypeMappingId}/documentation/descriptive-tags`);
	}

	@ApiMethod()
	public getCalendarBasedTags(token: string): Observable<Item<number, string>[]> {
		return this.http.get<Item<number, string>[]>(`${this.baseUrl}/job/${token}/documentation/calendar-based-tags`);
	}

	@ApiMethod()
	public getResourceAttributeLookupValues(token: string, attributeLookupListId: number) : Observable<{ id: number; value: string }[]> {
		return this.http.get<{ id: number; value: string }[]>( `${this.baseUrl}/job/${encodeURIComponent(token)}/attribute-lookup-lists/${attributeLookupListId}/values`);
	}
}